import { render, staticRenderFns } from "./supplierProduct.vue?vue&type=template&id=06e02ead&scoped=true&"
import script from "./supplierProduct.vue?vue&type=script&lang=js&"
export * from "./supplierProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e02ead",
  null
  
)

export default component.exports